module.exports = __webpack_public_path__ + "img/indicator_4.86070809.png";